import styled from "styled-components";

import { themePalette } from "../../../theme";

export const FAQSection = styled.section`
  width: 100%;
  box-sizing: border-box;
  margin-top: 20px;
  padding: 16px;
  border-radius: 8px;
  background: ${themePalette.white};
`;

export const FAQTitle = styled.h2`
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: ${themePalette.greyMedium};
`;

export const FAQAccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  text-align: left;

  .MuiPaper-root {
    margin: 0 !important;
    overflow: hidden;
    border: none;
    border-radius: 8px !important;
    background-color: ${themePalette.white};
    box-shadow: none;
    transition: background-color 0.2s ease;

    &.Mui-expanded {
      background-color: ${themePalette.neutral50};
    }

    &::before {
      display: none;
    }
  }

  .MuiAccordionSummary-root {
    min-height: 44px !important;
    padding: 8px 12px;

    &.Mui-expanded {
      min-height: 44px !important;
    }

    &:focus-visible {
      outline: 2px solid ${themePalette.redMedium};
      outline-offset: -2px;
    }
  }

  .MuiAccordionSummary-content {
    margin: 0 !important;
    padding-right: 8px !important;

    &.Mui-expanded {
      margin: 0 !important;
    }

    p {
      font-family: light !important;
      font-size: 15px !important;
      font-weight: 600 !important;
      line-height: 20px !important;
      color: ${themePalette.greyMedium};
    }
  }

  .MuiAccordionSummary-expandIconWrapper {
    margin-left: 4px;

    svg {
      color: ${themePalette.redMedium};
    }
  }

  .MuiAccordionDetails-root {
    padding: 12px !important;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${themePalette.greyMedium};

    p {
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      color: ${themePalette.greyMedium};
    }
  }
`;

export const FAQSupportSection = styled.div`
  margin-top: 16px;
`;

export const FAQSupportTitle = styled.h3`
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  color: ${themePalette.greyMedium};
`;

export const FAQSupportBody = styled.p`
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.45;
  color: ${themePalette.greyMedium};
`;

export const FAQSupportLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 1.45;

  a {
    color: ${themePalette.redMedium};
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  span {
    color: ${themePalette.greyLight};
  }
`;
